






































import { Component, Vue } from "vue-property-decorator";
import { Button, Dialog, Toast } from "vant";
import customField from "@/components/customField/index.vue";
import { showQuickVerification } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";
const browser = getBrowser();

@Component({
  components: {
    [Button.name]: Button,
    [customField.name]: customField
  }
})
export default class Login extends Vue {
  form = {
    password: "",
    confirm_password: "",
    zone_code: "",
    phone: "",
    from: 3, // 1ios，2Android，3web
    register_type: 1
  };
 get bgColor() {
  return this.$store.getters["common/bgColor"];
 }

  get isDisabledSubmit() {
    return !this.form.password || !this.form.confirm_password;
  }
  created() {
    const { zone_code, phone } = this.$route.query;
    if (typeof zone_code == "string") {
      this.form.zone_code = zone_code || "";
    }
    if (typeof phone == "string") {
      this.form.phone = phone || "";
    }
    //区分注册终端来源
    if (browser.isIosApp) {
      this.form.from = 1;
    } else if (browser.isAndroidApp) {
      this.form.from = 2;
    } else {
      this.form.from = 3;
    }
  }

  focus(){
    const appDom:any = document.getElementById('app')
    appDom.style.overflow = 'hidden';
    document.addEventListener('touchmove', this.preventScroll, { passive: false });
  }
  blur(){
    const appDom:any = document.getElementById('app')
    appDom.style.overflow = '';
    document.removeEventListener('touchmove', this.preventScroll);
  }
  preventScroll(e){
   e.preventDefault()
  }

  checkPassword() {
    const { password, confirm_password } = this.form;
    return password == confirm_password;
  }

  handleSubmit() {
    const bgColor:any = (this as any).$localstorage.get('BGColor')
    let color:any = this.bgColor  === 'white-theme' ? '' : 'black-theme-dialog'
    if(!this.bgColor){
      color = bgColor == 0 ? 'white-theme':'black-theme-dialog'
    }

    if(!this.regexValidatePassword(this.form.password)){
      return Toast.fail(this.$t("register.password_placeholder"));
    }

    if (!this.checkPassword()) {
      return Toast.fail(this.$t("register.password_verify_fail_text"));
    }
    (this as any).$apis
      .register(this.form)
      .then(res => {
        if ( res.msg ) {
          return false;
        }
        Dialog.alert({
          ["title" as any]: this.$t("common.tips"),
          ["message" as any]: this.$t("register.register_success_text"),
          ["className" as any]: color
        }).then(() => {
          
          // on close
          const { token, user_info } = res;
          (this as any).$localstorage.set("userInfo", user_info);
          sessionStorage.setItem("token", token);
          if((this as any).$route.query.open == 1){
            this.$router.push({
              path: '/open-account/home'
            })
          }else{
            if (browser.isGetProApp) {
              this.$router.push({
                path: "/mode-select"
              });
            } else if (browser.isApp) {
              showQuickVerification({ type: "1", data: res });
            } else {
              this.$router.push("/");
            }
          }
        });
      })
      .catch(e => {
        
      });
  }

  regexValidatePassword(password) {
    const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;

    return passwordRegex.test(password);
  }
}
